<!-- 静态页面-->
<template>
	<div class="container">
		<el-container v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
			<el-header class="header">
				<div class="logo">
					<span>
						供应商管理系统 V2.0.0
					</span>
					<el-menu mode="horizontal" router background-color="#303133" text-color="#fff" active-text-color="#ffd04b">
						<el-submenu index="name">
							<template slot="title"><i class="iconfont">&#xe611;</i>{{name}}</template>
							<el-menu-item :index="'/User/edit.html'">修改密码</el-menu-item>
						</el-submenu>
						<el-menu-item  @click="logout"><i class="iconfont">&#xe606;</i>退出</el-menu-item>
					</el-menu>
				</div>
			</el-header>
			<el-container>
				<el-aside width="250px" :style="menuHeight" v-if="menuLoad">
					<el-menu background-color="#606266" router text-color="#fff" active-text-color="#ffd04b">
						<template>

							<el-submenu index="a" v-auth="['supplier/setting']">
								<template slot="title">
									<i class="iconfont">&#xe618;</i>系统设置
								</template>
								<el-menu-item :index="'/Settings/basics.html'" v-auth="['supplier/data/info']"><i class="iconfont">&#xe702;</i>基础信息</el-menu-item>
								<el-menu-item :index="'/Settings/brandAuthorizing.html'" v-auth="['supplier/brandauth/listByPage']"><i class="iconfont">&#xe702;</i>品牌授权</el-menu-item>
								<el-menu-item :index="'/Settings/role.html'" v-auth="['supplier/role/index']"><i class="iconfont">&#xe702;</i>角色管理</el-menu-item>
								<el-menu-item :index="'/Settings/index.html'" v-auth="['supplier/seller/index']"><i class="iconfont">&#xe702;</i>账号管理</el-menu-item>
<!--								<el-menu-item :index="'/Sms/index.html'"><i class="iconfont">&#xe702;</i>短信配置</el-menu-item>-->
								<el-menu-item :index="'/Settings/freight.html'" v-auth="['supplier/delivery/list']"><i class="iconfont">&#xe702;</i>运费配置</el-menu-item>
<!--								<el-menu-item :index="'/Address/index.html'"><i class="iconfont">&#xe702;</i>退货地址</el-menu-item>-->
							</el-submenu>

							<el-submenu index="b" v-auth="['supplier/goods']">
								<template slot="title">
									<i class="iconfont">&#xe6e9;</i>商品管理
								</template>
								<el-menu-item :index="'/Category/index.html'" v-auth="['supplier/productCategory/listTreeByPid']"><i class="iconfont">&#xe702;</i>商品分类</el-menu-item>
								<el-menu-item :index="'/Goods/index.html'" v-auth="['supplier/product/list']"><i class="iconfont">&#xe702;</i>在售商品</el-menu-item>
								<el-menu-item :index="'/Goods/off.html'" v-auth="['supplier/product/list']">
									<i class="iconfont">&#xe702;</i>下架商品
								</el-menu-item>
								<el-menu-item :index="'/Goods/reviewed.html'" v-auth="['supplier/product/list']"><i class="iconfont">&#xe702;</i>已通过-商品</el-menu-item>
								<el-menu-item :index="'/Goods/unreviewed.html'" v-auth="['supplier/product/list']"><i class="iconfont">&#xe702;</i>待审核-商品</el-menu-item>
								<el-menu-item :index="'/Goods/reject.html'" v-auth="['supplier/product/list']"><i class="iconfont">&#xe702;</i>被驳回-商品</el-menu-item>
							</el-submenu>

							<el-submenu index="c" v-auth="['supplier/stock']">
								<template slot="title">
									<i class="iconfont">&#xe680;</i>库存管理
								</template>
								<el-menu-item :index="'/Repertory/index.html'" v-auth="['supplier/stock/listStock']"><i class="iconfont">&#xe702;</i>库存管理</el-menu-item>
								<el-menu-item :index="'/Repertory/outInwarehouse.html'" v-auth="['supplier/stock/addStockIn']"><i class="iconfont">&#xe702;</i>商品入库</el-menu-item>
								<el-menu-item :index="'/Repertory/in.html'" v-auth="['supplier/stock/listStockIn']"><i class="iconfont">&#xe702;</i>入库查询</el-menu-item>
								<el-menu-item :index="'/Repertory/out.html'" v-auth="['supplier/stock/listStockOut']"><i class="iconfont">&#xe702;</i>出库查询</el-menu-item>
							</el-submenu>

							<el-submenu index="d" v-auth="['supplier/order']">
								<template slot="title">
									<el-badge :value="count.new_order_count + count.refunding_count" class="item">
										<i class="iconfont">&#xe642;</i>订单管理
									</el-badge>
								</template>
								<el-menu-item :index="'/Indent/index.html'" v-auth="['supplier/order/list']">
									<el-badge :value="count.new_order_count" class="item">
										<i class="iconfont">&#xe702;</i>订单汇总
									</el-badge>
								</el-menu-item>
<!--								<el-menu-item :index="'/Indent/unfinished.html'"><i class="iconfont">&#xe702;</i>未完成订单</el-menu-item>-->
								<el-menu-item :index="'/Indent/dropShipping.html'" v-auth="['supplier/order/list']"><i class="iconfont">&#xe702;</i>待发货订单</el-menu-item>
								<el-menu-item :index="'/Indent/forGoods.html'" v-auth="['supplier/order/list']"><i class="iconfont">&#xe702;</i>待收货订单</el-menu-item>
								<el-menu-item :index="'/Indent/complete.html'" v-auth="['supplier/order/list']"><i class="iconfont">&#xe702;</i>已完成订单</el-menu-item>
								<el-menu-item :index="'/Refund/index.html'" v-auth="['supplier/order.refund/list']">

									<el-badge :value="count.refunding_count" class="item">
										<i class="iconfont">&#xe702;</i>售后退货退款管理
									</el-badge>
								</el-menu-item>
								<el-menu-item :index="'/Indent/cancel.html'" v-auth="['supplier/order/list']">

									<el-badge :value="count.cancel_count" class="item">
										<i class="iconfont">&#xe702;</i>售后退款管理
									</el-badge>
								</el-menu-item>
<!--								<el-menu-item :index="'/Indent/return.html'"><i class="iconfont">&#xe702;</i>退换货管理</el-menu-item>-->
							</el-submenu>

							<el-submenu index="e">
								<template slot="title">
									<i class="iconfont">&#xe633;</i>财务管理
								</template>
<!--								<el-menu-item :index="'/Finance/water.html'"><i class="iconfont">&#xe702;</i>财务流水</el-menu-item>-->
<!--								<el-menu-item :index="'/Finance/statement.html'"><i class="iconfont">&#xe702;</i>订单汇总</el-menu-item>-->
								<el-menu-item :index="'/Finance/check.html'" v-auth="['supplier/Finance/index']"><i class="iconfont">&#xe702;</i>对账单</el-menu-item>
							</el-submenu>
						</template>
					</el-menu>
				</el-aside>
				<el-container>
					<el-main :style="mainHeight">
						<transition :name="transitionName">
							<router-view class="router-view" v-if="menuLoad"></router-view>
						</transition>
					</el-main>
					<el-footer height="40px">
<!--						{{setting.copyright}}-->
					</el-footer>
				</el-container>
			</el-container>
		</el-container>
	</div>
</template>
<script>
export default {
	data() {
		return {
			mainHeight:{
				height: ""
			},
			menuHeight:{
				height: "",
				"overflow-x":"hidden"
			},
			transitionName:'',
			isLoad:false,
			menu:[],
			setting:{},
			name:localStorage.login_name,
			uid:'',
			menuLoad: false,
			count: {}
		}
	},
	created() {
		window.addEventListener("resize", this.setHeight);
		this.loadMain()
		this.setHeight();
		this.loadMenu()
	},
	methods: {
		loadMain: function () {
			//获取统计信息
			this.axios.get('supplier/data/count').then(res => {
				this.count = res.data.count
			}).catch((res) => {

			})
		},
		setHeight() {
			this.mainHeight.height = window.innerHeight - 100 + "px";
			this.menuHeight.height = window.innerHeight - 60 + "px";
		},

		loadMenu() {
			this.axios.get('supplier/data/menus').then(res => {
				this.menuLoad = true
				this.$store.dispatch('admin/user/set', {
					user: res.data.user,
					access: res.data.menus,
				});
			}).catch(() => {
			})
		},
		logout(){
			localStorage.clear();
			this.$message.success({
				message: '退出成功',
				showClose:false
			});
			this.$router.replace({ path:'/Login.html'});
		}
	},
	watch: {
		$route() {
			this.transitionName = 'el-fade-in-linear'
			this.loadMain()
		},
	}
}
</script>
<style scoped>
	.el-menu-item.is-active{
		background-color: #444444 !important;
	}
.iconfont{
	vertical-align: middle;
	margin-right: 5px;
	margin-top: -4px;
	width: 24px;
	text-align: center;
	font-size: 18px;
	color: rgb(255,255,255);
}

	.main{
	min-height: 100%;
	padding: 20px;
}
.el-main{
	padding: 0;
}
.container .header{
	background: #303133;
}
.container .el-menu{
	height: 100%;
	border:none;
}
.container .logo{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.container .logo span{
	color: rgb(255, 208, 75);
	font-size: 18px;
}
.container .el-footer{
	background-color: #DCDFE6;
	align-items: center;
	display: flex;
}
</style>
